import React from "react";
import liveSessionBanner from "../../../../../../assets/images/LearningSession/liveSessionBanner.png";
import RequestCompTablePagination from "../RequestCompTablePagination/RequestCompTablePagination";
import "./RequestForCertificate.css";

const RequestForCertificate = () => {
  return (
    <div className="m-2 border border-warning rounded-3">
      <div className=" p-3">
        <div className="d-flex my-2">
          <h3 className="text-light mx-2">Certificate Content</h3>
          <div className="underLine"></div>
        </div>

        <div className="my-3">
          <img
            src={liveSessionBanner}
            alt=""
            className="rounded img-fluid w-100 mobileNx"
          />
        </div>

        <div>
          <div className="my-3 py-3 px-3 my-2 bgRequest">
            <h4 className="text-dark fw-bold rounded-1">
              {" "}
              Request for Certificate
            </h4>
          </div>

          <div>
            <RequestCompTablePagination />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RequestForCertificate;
